<app-loader-landing *ngIf="showLoading"></app-loader-landing>
<router-outlet #outlet="outlet" (activate)="onActivate()"></router-outlet>